import { Flex, ProgressBar, Text } from '@spotify-internal/encore-web';
import { BUCKET_COUNT } from '@spotify/confidence-core-react';
import { formatWeight } from '@spotify/plugin-confidence-workflows-react';

interface Treatment {
  label: string;
  weight: number;
}

const TreatmentBar = ({ label, weight }: Treatment) => (
  <Flex direction="column" gap="tighter-2">
    <Flex alignItems="center" justifyContent="space-between">
      <Text variant="bodySmall">{label}</Text>
      <Text variant="bodySmall" semanticColor="textSubdued">
        {formatWeight(weight)}
      </Text>
    </Flex>
    <ProgressBar value={(weight / BUCKET_COUNT) * 100} />
  </Flex>
);

interface TreatmentBarListProps {
  treatments: ReadonlyArray<Treatment>;
}

export const TreatmentBarList = ({ treatments }: TreatmentBarListProps) => {
  if (treatments.length === 0) {
    return (
      <Text variant="bodySmall" semanticColor="textSubdued">
        No treatments.
      </Text>
    );
  }
  return (
    <Flex direction="column" gap="tighter">
      {treatments.map((treatment, index) => (
        <TreatmentBar
          key={`${treatment.label}-${index}`}
          label={treatment.label}
          weight={treatment.weight}
        />
      ))}
    </Flex>
  );
};
